<script setup>
import { Dropdown } from 'floating-vue'
import UserAvatar from '~/components/Common/UserAvatar.vue'

const props = defineProps({
  minimal: {
    type: Boolean,
    default: false,
  }
})

const authStore = useAuthStore()
const { activeRole } = useRolePermissions()
const { t } = useI18n()

const dropdownRef = ref(null)

const user = computed(() => authStore.user)

const displayName = computed(() => user.value?.displayName || 'Usuario')

const roleLabel = computed(() => {
  if (!activeRole.value) return ''
  return t(`roles.${activeRole.value}`)
})

const closeDropdown = () => {
  if (dropdownRef.value) {
    dropdownRef.value.hide()
  }
}

const handleLogout = () => {
  closeDropdown()
  navigateTo('/logout')
}

const handleProfileClick = () => {
  closeDropdown()
  navigateTo('/profile')
}
</script>

<template>
  <Dropdown
    ref="dropdownRef"
    placement="top-end"
    :distance="8"
  >
    <div class="flex items-center gap-3 px-3 py-3 mt-2 cursor-pointer">
      <UserAvatar
        :avatar="user?.avatar"
        :display-name="displayName"
        :size="props.minimal ? 'md' : 'md'"
      />
      <div class="flex flex-col overflow-hidden" v-if="!minimal">
        <p class="text-slate-900 dark:text-white text-sm font-bold truncate">{{ displayName }}</p>
        <p class="text-slate-500 dark:text-slate-400 text-xs truncate">{{ roleLabel }}</p>
      </div>
    </div>

    <template #popper>
      <div class="bg-white dark:bg-slate-900 rounded-lg shadow-lg border border-slate-200 dark:border-slate-700 py-2 min-w-[200px]">
        <div class="px-4 py-3 border-b border-slate-200 dark:border-slate-700">
          <p class="text-slate-900 dark:text-white text-sm font-bold truncate">{{ displayName }}</p>
          <p class="text-slate-500 dark:text-slate-400 text-xs truncate">{{ roleLabel }}</p>
        </div>
        <button
          @click="handleProfileClick"
          class="w-full px-4 py-2 text-left text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors flex items-center gap-2"
        >
          <Icon name="heroicons:user-circle" class="text-lg" />
          <span>Mi perfil</span>
        </button>
        <button
          @click="handleLogout"
          class="w-full px-4 py-2 text-left text-sm text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors flex items-center gap-2"
        >
          <Icon name="mdi:logout" class="text-lg" />
          <span>Cerrar sesión</span>
        </button>
      </div>
    </template>
  </Dropdown>
</template>
